'use client';
import { faMoonStars, faSunBright } from '@fortawesome/pro-regular-svg-icons';
import { Flex, Select, Tooltip, Icon } from '@scale/scaleui-radix';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

const data = {
  light: { label: 'Scale Light', icon: <Icon icon={faSunBright} label="Scale Light" /> },
  dark: { label: 'Scale Dark', icon: <Icon icon={faMoonStars} label="Scale Dark" /> },
  duneLight: { label: 'Dune Light', icon: <Icon icon={faSunBright} label="Dune Light" /> },
  duneDark: { label: 'Dune Dark', icon: <Icon icon={faMoonStars} label="Dune Dark" /> },
  outlierLight: {
    label: 'Outlier Light',
    icon: <Icon icon={faSunBright} label="Outlier Light" />,
  },
  outlierDark: {
    label: 'Outlier Dark',
    icon: <Icon icon={faMoonStars} label="Outlier Dark" />,
  },
  outlierV2Light: {
    label: 'Outlier V2 Light',
    icon: <Icon icon={faSunBright} label="Outlier V2 Light" />,
  },
  outlierV2Dark: {
    label: 'Outlier V2 Dark',
    icon: <Icon icon={faMoonStars} label="Outlier V2 Dark" />,
  },
};

export function ThemeToggle() {
  const [mounted, setMounted] = useState(false);
  const { theme = 'light', setTheme } = useTheme();

  // useEffect only runs on the client, so now we can safely show the UI
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <Select.Root onValueChange={setTheme} value={theme}>
      {/* Add a custom color variable that changes between light and dark mode */}
      {theme === 'duneLight' || theme === 'duneDark' ? (
        <style>{` @import '/dune-styles.css'; `}</style>
      ) : theme === 'outlierLight' || theme === 'outlierDark' ? (
        <style>{` @import '/outlier-styles.css'; `}</style>
      ) : theme === 'outlierV2Light' || theme === 'outlierV2Dark' ? (
        <style>{` @import '/outlier-v2-styles.css'; `}</style>
      ) : null}
      <Tooltip content="Change theme">
        <Select.Trigger>
          <Flex align="center" as="span" gap="2">
            {data[theme]?.icon}
            {data[theme]?.label}
          </Flex>
        </Select.Trigger>
      </Tooltip>
      <Select.Content>
        <Select.Group>
          <Select.Item value="light">Scale Light</Select.Item>
          <Select.Item value="dark">Scale Dark</Select.Item>
        </Select.Group>
        <Select.Separator />
        <Select.Group>
          <Select.Item value="outlierLight">Outlier Light</Select.Item>
          <Select.Item value="outlierDark">Outlier Dark</Select.Item>
        </Select.Group>
        <Select.Separator />
        <Select.Group>
          <Select.Item value="outlierV2Light">Outlier V2 Light</Select.Item>
          <Select.Item value="outlierV2Dark">Outlier V2 Dark</Select.Item>
        </Select.Group>
        <Select.Separator />
        <Select.Group>
          <Select.Item value="duneLight">Dune Light</Select.Item>
          <Select.Item value="duneDark">Dune Dark</Select.Item>
        </Select.Group>
      </Select.Content>
    </Select.Root>
  );
}
